import React, { useState } from 'react';

// Create a context object
const UserContext = React.createContext(null);

// Create a provider component
const UserProvider = ({ children }) => {
  const [user, setUser] = useState({}); // State to hold user data

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider }; // Export both the context and provider